import { render, staticRenderFns } from "./UserDetailnovelties.vue?vue&type=template&id=3745f942"
import script from "./UserDetailnovelties.vue?vue&type=script&lang=js"
export * from "./UserDetailnovelties.vue?vue&type=script&lang=js"
import style0 from "./UserDetailnovelties.vue?vue&type=style&index=0&id=3745f942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports